export interface BibleTestimonial {
  id: string
  quote: string
  name: string
  role: string
  initials: string
}

export const bibleTestimonials: BibleTestimonial[] = [
  {
    id: 't1',
    quote:
      'Dejé de copiar prompts sueltos. Ahora defino la escena, la luz y la cámara antes de generar, y mis imágenes de producto por fin se parecen a lo que tenía en la cabeza.',
    name: 'Mariana Torres',
    role: 'Tienda de skincare · Guadalajara',
    initials: 'MT'
  },
  {
    id: 't2',
    quote:
      'Lo que más me sirvió fue la estructura por bloques para video. Planifico la secuencia en papel y llego a la herramienta sabiendo qué pedir en cada toma.',
    name: 'Andrés Peralta',
    role: 'Editor freelance · Buenos Aires',
    initials: 'AP'
  },
  {
    id: 't3',
    quote:
      'Usé los ejemplos del Command Console para tres marcas distintas cambiando las variables. Me ahorró horas de prueba y error en cada entrega.',
    name: 'Daniela Suárez',
    role: 'Agencia creativa · Madrid',
    initials: 'DS'
  },
  {
    id: 't4',
    quote:
      'Los ganchos visuales me dieron ideas de apertura que no se me habrían ocurrido. Ahora el primer segundo del anuncio tiene una intención clara.',
    name: 'Josué Ramírez',
    role: 'Media buyer · Miami',
    initials: 'JR'
  },
  {
    id: 't5',
    quote:
      'Soy principiante y aun así pude seguir el material. Entender por qué cambia una imagen cuando ajusto una variable fue el clic que me faltaba.',
    name: 'Camila Rojas',
    role: 'Emprendedora · Santiago',
    initials: 'CR'
  },
  {
    id: 't6',
    quote:
      'La comunidad en Skool vale el acceso por sí sola. Publico lo que hago, veo el prompt de otros y adapto lo que funciona a mis propios proyectos.',
    name: 'Ricardo Vega',
    role: 'Fotógrafo de producto · Lima',
    initials: 'RV'
  }
]
